import {
    GET_GROUPS_LIST_REQUEST, GET_GROUPS_LIST_SUCCESS, GET_GROUPS_LIST_FAILURE, SET_GROUPS_FILTERED,
} from '../constants/get_groups_list.constants';

const initialState = {
    User_group_list: {
        loading: false,
        error: null,
        groupsList: [],
        filteredGroups: [],
    },
};

export const User_group = (state = initialState, action) => {
    switch (action.type) {
    case GET_GROUPS_LIST_REQUEST:
        return {
            ...state,
            User_group_list: {
                ...state.User_group_list,
                loading: true,
            },
        };

    case GET_GROUPS_LIST_SUCCESS:
        return {
            ...state,
            User_group_list: {
                ...state.User_group_list,
                groupsList: action.groupsList,
                filteredGroups: action.groupsList,
                loading: false,
            },
        };

    case SET_GROUPS_FILTERED:
        const { searchText } = action;
        const data = searchText.toLowerCase();

        const groupsFiltered = [];

        state.User_group_list.groupsList.map((item) => {
            const abbr = item.abbr ? item.abbr.toLowerCase() : '';
            const name = item.name ? item.name.toLowerCase() : '';

            if (abbr.includes(data) || name.includes(data)) {
                groupsFiltered.push(item);
            }
            return groupsFiltered;
        });

        return {
            ...state,
            User_group_list: {
                ...state.User_group_list,
                loading: false,
                filteredGroups: groupsFiltered,
            },
        };

    case GET_GROUPS_LIST_FAILURE:
        return {
            ...state,
            User_group_list: {
                ...state.User_group_list,
                loading: false,
                error: action.error,
            },
        };

    default:
        return state;
    }
};



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_group/redux/reducers/get_groups_list.reducers.js